
import { Pagination } from '@store/common/pagination.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { User } from '@store/settings/users';
import {AuditOperation} from '@store/audits/audits-operation/audits-operation.model';

export namespace TemplatesFilters {
  export const initTableFilters = () =>
    TableFilterType.initTableFilters([
      TableFilterType.STATUS,
    ]);
}

export interface TemplatesFilters {
  search: string;
  sortBy?: string;
  orderBy?: string;
  tableFilters: TableFilter[];
}


export interface TemplatesPagination extends Pagination {
  data: Templates[];
}

export interface TemplatesUI {
  id: number;
  selected: boolean;
}

export interface CreateTemplateDto {
  auditId: number;
  name: string;
}

export interface Templates {
  id: number;
  name: string;
  auditInformationPreAudit: string[];
  auditInformationAudit: string[];
  auditOperation: AuditOperation[];
  author: User;
  updatedAt: Date;
}